import { Component, OnInit, Input } from '@angular/core';
import { GtagService } from 'src/app/services/gtag.service';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'produto-item',
  templateUrl: './produto-item.component.html',
  styleUrls: ['./produto-item.component.scss']
})
export class ProdutoItemComponent implements OnInit {

  @Input("lazy") lazy                         = false;
  @Input("data") produto:any                  = {};   
  @Input("isLazy") isLazy:any                 = false;    
  @Input("categoria") categoria:any           = null; 
  @Input("index") index:any                   = 0; 
  @Input("nome_lista") nome_lista:any         = "Página de Serviços";
  @Input("classCustom") classCustom:any       = "";
  @Input("apelidoDestino") apelidoDestino     = null;   
  @Input("apelidoCategoria") apelidoCategoria = null; 
  @Input("maxText") maxText                  = "60";
  public link                                 = null;   
  public defaultImage                         = "/images/produto/sem-foto/default-capa.jpg";
  public beneficios                           = [];
  public configuracao = null;
  public color = null;
  @Input("lp") lp:any = null; 
  @Input("template") template:any = 1;

  constructor( 
    private gtag: GtagService,
    private route: Router,
    private dataService: DataService
  ){
    
    this.isLazy = this.isLazy === true || this.isLazy === "true" ? true : false;  
    
  } 

  /**
   * 
   * Click
   * 
   */
  _click(){

    if(!this.produto.link_externo_ativo){
      this.route.navigateByUrl(this.link);
    }else{
      window.open(this.produto.link_externo,"_blank"); 
    }

    return false;

  }
  /**
   * 
   * Seta o link para o detalhe do produto
   * 
   */
  setLink(){

    if(this.lp ==  null){
      
      if(this.apelidoDestino == null){
        if(this.categoria ==  null){
          this.link = "/servicos/"+this.produto.categoria_apelido+"/"+this.produto.apelido;
        }else{
          this.link = "/servicos/"+this.categoria.apelido+"/"+this.produto.apelido;
        }
      }else{
        this.link = "/destinos/"+this.apelidoDestino+"/"+this.apelidoCategoria+"/"+this.produto.apelido;
      }

    }else{

      if(this.categoria ==  null){
        this.link = "/lp/"+this.lp+"/servicos/"+this.produto.categoria_apelido+"/"+this.produto.apelido;
      }else{ 
        this.link = "/lp/"+this.lp+"/servicos/"+this.categoria.apelido+"/"+this.produto.apelido;
      }

    }
    

  }
  /**
   * 
   * On click
   * 
   */
  onClick(){

    try{
      
      this.route.navigateByUrl(this.link);

      this.gtag.selectProduct({
        id: this.produto.id,
        nome: this.produto.nome,
        categoria: this.produto.categoria_titulo,
        list_name: this.nome_lista,
        list_position: this.index+1 
      });

    }catch(e){
      
    }
  
  }
  /**
   * 
   * Set Benefícios
   * 
   */
  setBeneficios(){

    if(typeof(this.produto.beneficios)){

      this.beneficios = this.produto.beneficios; 

    }

  }
   /**
   * 
   * Formatar foto
   * 
   */
  formatarFoto(){

    this.produto.foto = this.produto.foto != null ? this.produto.foto.replace(".png",".jpg") : null;  

  }
  /**
   * 
   * Set color
   * 
   */
   setColor(){

    if(this.configuracao != null){

      this.color = this.configuracao.cor_2;

    }

  }
  /**
   * 
   * Inicializa as Funções
   * 
   * 
   */
  ngOnInit(){
    this.setLink();
    this.setBeneficios();
    this.formatarFoto();
    this.configuracao = this.dataService.getConfiguracao();
    this.setColor();
  }

}
